var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('menu-navigation',{staticClass:"navigation--minimal",attrs:{"apply-link":_vm.applyLink}}),_vm._v(" "),_c('div',{staticClass:"layout layout--overflowed"},[_c('nuxt')],1),_vm._v(" "),_c('client-only',[_c('dn-cookiebar')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }